import { Component, Input } from '@angular/core';
import { SignInService } from './sign-in.service';
import { SdkTesterService } from '../sdk-tester.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrl: './sign-in.component.scss',
    imports: [CommonModule, FormsModule, ReactiveFormsModule]
})
export class SignInComponent {
    userNameError = false;
    orgError = false;
    SignInService!: SignInService;
    SdkTesterService!: SdkTesterService;
    @Input() inAdvancedMode = false;
    constructor(private signInService: SignInService, private sdkTesterService: SdkTesterService) {
        this.SignInService = this.signInService;
        this.SdkTesterService = this.sdkTesterService;
    }

    get username(): any {
        return this.signInService.signInForm.get('username');
    }

    get organization(): any {
        return this.signInService.signInForm.get('organization');
    }
}
